export const buildNumber = '20260817.2';
export const version = '3.14.2';
export const latestCommit = '877584589874fb91f4d3643107602e1005fba730';
